import { Star } from 'lucide-react'

export function StarRating({ rating, size = 16 }: { rating: number; size?: number }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map(i => (
        <Star
          key={i}
          className={i <= rating ? 'text-amber-400 fill-amber-400' : 'text-[#555A73]'}
          size={size}
          strokeWidth={1.25}
        />
      ))}
    </div>
  )
}
